module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    ref: "mainArea",
    staticClass: "welcome-container"
  }, [_c('div', {
    staticClass: "welcome-text-Container"
  }, [_vm._v("\n            欢迎进入" + _vm._s(_vm.subsystemName) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc7da8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcome.vue
// module id = 1773
// module chunks = 502